import React from "react";

// Indicator de tip "lampă bord" pentru kilometri scurși de la ultima revizie.
//   gap > 20000 km → roșu (urgent)
//   gap > 15000 km → portocaliu
//   gap > 10000 km → galben
//   altfel       → null (nu se afișează)
export function ServiceLamp({ gap, size = 18 }) {
  if (!gap || gap <= 10000) return null;
  let color, status;
  if (gap > 20000) { color = "#DC2626"; status = "URGENT"; }
  else if (gap > 15000) { color = "#F97316"; status = "Scadentă"; }
  else { color = "#EAB308"; status = "Programare recomandată"; }
  const tooltip = `${Math.round(gap).toLocaleString("ro-RO")} km de la ultima revizie · ${status}`;
  return (
    <span title={tooltip} data-testid="service-lamp" className="inline-flex" style={{ color }}>
      <svg width={size} height={size} viewBox="0 0 64 64" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-label="Revizie scadentă">
        {/* corpul recipientului */}
        <path d="M5 22 L20 22 L20 14 L24 14 L24 22 L27 22 L27 18 L40 18 L40 22 L52 22 L60 28 L58 50 L8 50 L5 22 Z" />
        {/* picătura */}
        <path d="M58 36 C 60 40, 62 44, 60 48 C 58 51, 54 51, 52 48 C 50 44, 52 40, 54 36 C 55 35, 57 35, 58 36 Z" />
      </svg>
    </span>
  );
}
